import React from 'react'
import {submitRefTableData, insertNewRefTableData, getFeConfig, visualizeCountryVatItemsNonEU} from "../api/api";
import { Table, Form } from "@q4us-sw/q4us-ui";
import {Button, Modal, Space, notification} from 'antd'
import {
    AppstoreAddOutlined,
} from "@ant-design/icons"
import TableDataSource from "../utils/TableDataSource";


export const CountryVatItemNonEU = (props) => {

    const [open, setOpen] = React.useState(false);
    const [source, setSource] = React.useState(new TableDataSource());


    return <React.Fragment>
        <Space direction={`vertical`} style={{width:"100%"}}>
            <div style={{textAlign: 'right', paddingRight: 7,width: '100%'}} >
                <Button style={{width: 160}} icon={<AppstoreAddOutlined/>} onClick={()=>setOpen(true)}>Add New Item</Button>
            </div>
            <Table
                fetchConfig={async () => {
                    const { data = {} } = await getFeConfig('country_vat_item')
                    const { statusCode, rows = [], fields = [] } = data;
                    const rows2 = rows.map( x=> {
                        if(x.name === 'hs6p_code'){
                            const formatter = (row, index, name, type, formatted, value) =>{
                                return value.toString().replace(/^(\d{4})(\d{2})/g, '$1 $2 ')
                            }
                            return {...x, formatter}
                        }
                        return x
                    })

                    return { data: { statusCode, rows: rows2, fields } };
                }}
                scroll={{y: 'calc(90vh - 40px)', x: true }}
                fetchData={async () => {
                    return await visualizeCountryVatItemsNonEU(props.country_vat_rate_id)
                }}

                saveData={async (data) => {
                    data['timestamp'] = new Date().toUTCString();

                    const { data: { statusCode = 400, rows = [] } = {} } = await submitRefTableData(data, 'country_vat_item_non_eu');
                    return { data: { statusCode, rows: [data] } };
                }}

                editable={false}

                source={source}
            />
        </Space>

        <Modal
            centered
            closable={true}
            onCancel={()=>setOpen(false)}
            footer={null}
            title={`Add New Item`}
            visible={open}
        >
            <Form maxHeight={`60vh`} schema={'country_vat_item_non_eu'} config={async () => {
                const res = await getFeConfig('country_vat_item_form') || {}
                const { data: { rows = [] } = {} } = res;

                const rows2 = rows.filter(({ generated }) => !generated).sort(({ sequence_no: a }, { sequence_no: b }) => {return a - b});

                return rows2.map(o => {
                    if (o.name === 'hs6p_code') {
                        const format = { regex: /\D/g, format: '' }
                        const mask = { regex: /^(\d{4})(\d{1,2})/g, format: '$1 $2 ' }
                        return { ...o, format, mask }
                    }
                    return o;
                });

            }}
                  submit={async (values) => {
                      values['country'] = props.country;
                      values['country_vat_rate_id'] = props.country_vat_rate_id;
                      values['hs6p_code'] = values['hs6p_code'].replace(/\D/g, '')
                      const {data} = await insertNewRefTableData(values,'country_vat_item_non_eu');
                      if(data.statusCode === 200){
                          notification.success({message: `New record added to country_vat_item_non_eu`})
                      }
                      else if(data.message.includes('duplicate')){
                          notification.error({message:`HS6+ already available for the selected country. To change rate type, please remove from existing type and insert to the new type.`, duration:4})
                      }
                      else if(data.message.includes('foreign')){
                          notification.error({message:`Inserted HS6+ code is not available. Please insert to the HS6+ table and try again.`, duration:4})
                      }
                      return true;
                  }}  />
        </Modal>


    </React.Fragment>
}